import { render, staticRenderFns } from "./shopForm.vue?vue&type=template&id=bb3314a6&scoped=true"
import script from "./shopForm.vue?vue&type=script&lang=js"
export * from "./shopForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./shopForm.vue?vue&type=style&index=1&id=bb3314a6&prod&lang=scss&scoped=true"
import style2 from "./shopForm.vue?vue&type=style&index=2&id=bb3314a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3314a6",
  null
  
)

export default component.exports